import React from 'react';
import { Button, Input } from 'antd';
import { Field } from 'redux-form';
import { SelectField } from 'redux-form-antd';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import FormValueSelector from '../../../containers/FormValueSelector';

const InputGroup = Input.Group;

const CreativeSelect = ({
  loading,
  handleSubmit,
  creativeList,
  activeList,
  multiple,
  disabled,
  showCreativeModal,
}) => (
  <InputGroup compact>
    <Field
      mode={multiple ? 'multiple' : 'default'}
      loading={loading}
      format={a => (a ? (Array.isArray(a) ? a.map(b => `${b}`) : `${a}`) : a)}
      name="creative_service_id"
      component={SelectField}
      labelKey="name"
      showSearch
      optionFilterProp="name"
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      valueKey="creative_service_id"
      options={creativeList.filter(a => !activeList.includes(a.creative_service_id))}
      placeholder="Select a creative"
      style={{ width: 300 }}
    />
    <FormValueSelector fieldName="creative_service_id">
      {id => {
        return (
          <div style={{ lineHeight: '40px' }}>
            <Button onClick={handleSubmit} key={2} loading={loading} disabled={disabled}>
              Include
            </Button>
            {!multiple && (
              <Button
                onClick={() => showCreativeModal({ creative_service_id: id })}
                disabled={!id}
                type="link"
              >
                View Creative
              </Button>
            )}
          </div>
        );
      }}
    </FormValueSelector>
  </InputGroup>
);

export default compose(withRouter)(CreativeSelect);
